import { handleLogout } from 'ComponentsV2/ProjectDashboard/utils/handleLogout';
import * as ls from 'local-storage';
import { apiInterceptor } from 'utils/apiInterceptor';

/**
 * gets the current user based from authorisation token
 */
// eslint-disable-next-line import/prefer-default-export
export async function getUser() {
    const auth = ls.get('auth');
    if (auth !== 'authenticated') return null;

    const response = await apiInterceptor(
        `${process.env.REACT_APP_MYXP_API}/manager/users/profile`,
        {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        }
    );

    if (response.status === 403) {
        return handleLogout();
    }

    return await response.json();
}
